// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class ReminderAPI extends MainAPI {
	/**
	 * @return {*} reminder list
	 */
	async getReminderLists(reminderDetails) {
		return API.get(`${ENDPOINTS.GET_REMINDER}?${queryString.stringify(reminderDetails)}`);
	}

	/**
	 * @return {*} reminder list
	 */
	async saveReminder(reminderDetails) {
		return API.post(ENDPOINTS.GET_REMINDER, reminderDetails);
	}

	/**
	 * @return {*} reminder list
	 */
	async updateReminder(reminderId, reminderDetails) {
		return API.put(`${ENDPOINTS.GET_REMINDER}/${reminderId}`, reminderDetails);
	}

	/**
	 * @return {*} reminder list
	 */
	async updateReminderStatus(reminderId, reminderDetails) {
		return API.put(`${ENDPOINTS.GET_REMINDER}/${reminderId}/status`, reminderDetails);
	}
}

export default new ReminderAPI();
